import {API_BASE_URL} from '../config'

// eslint-disable-next-line no-unused-vars
import { get, post, put, remove, upload } from '../config/api'

export const uploadURL = API_BASE_URL + '/api/v1/uploads'

/**
 * 上传文件
 * @param {*} data
 */
export const uploadFile = (data) => upload(`/api/v1/uploads`, data)

/**
 * 用户登录
 * @param {*} data
 */
export const userLogin = (data) => post(`/api/en/v1/auth/login`, data)

/**
 * 用户注册
 */
export const userRegister = (data) => post(`/api/en/v1/auth/register`, data)

/**
 * 注册时发送邮箱验证码
 * @param {*} data
 */
export const sendRegisterMailCode = (data) => post(`/api/en/v1/auth/sendCodeReg`, data)

/**
 * 忘记密码发送邮箱验证码
 * @param {*} data
 */
export const sendPasswordMailCode = (data) => post(`/api/en/v1/auth/sendCodeGet`, data)

/**
 * 用户忘记密码时,修改密码
 * @param {*} data
 */
export const userForgetPassword = (data) => post(`/api/en/v1/auth/forget`, data)

/**
 * 获取了解途径列表
 * @param {*} data
 */
export const getWayOptions = (data) => get(`/api/v1/source/list`, data)

/**
 * 获取用户信息(通用)
 * @param {*} data
 */
export const getUserInfo = (data) => get(`/api/v1/me`, data)

/**
 * 更新用户信息
 * @param {*} data
 */
export const updateUserInfo = (data) => put('/api/v1/me', data)

/**
 * 获取学科列表
 * @param {*} data
 */
export const getSubjectList = (data) => get(`/api/v1/subject/list`, data)

/**
 * 提交稿件信息
 * @param {*} data
 */
export const submitPaper = (data) => post(`/api/en/v1/manuscript/submit`, data)

/**
 * 获取平台服务列表
 * @param {*} data
 */
export const getServiceList = (data) => get(`/api/v1/service/list`, data)

/**
 * 获取平台服务列表，有服务类别分组
 * @param {*} data
 */
export const getServiceListByTag = (data) => get(`/api/v1/service/list/new`, data)

/**
 * 获取我的稿件列表
 * @param {*} data
 */
export const getMyPaperList = (data) => get(`/api/v1/manuscript/list`, data)

/**
 * 稿件支付
 * @param {*} data
 */
export const payForMyPaper = (manuscriptId, data) => post(`/api/en/v1/manuscript/${manuscriptId}/pay`, data)

/**
 * 获取用户稿件详情
 * @param {*} manuscriptId
 * @param {*} data
 */
export const getMyPaperInfo = (manuscriptId, data) => get(`/api/v1/manuscript/${manuscriptId}/get`, data)

/**
 * 获取稿件附件列表
 * @param {*} manuscriptId
 * @param {*} data
 */
export const getPaperAttachmentList = (manuscriptId, data) => get(`/api/v1/manuscript/${manuscriptId}/attachments`, data)

/**
 * 添加稿件留言
 * @param {*} manuscriptId
 * @param {*} data
 */
export const addPaperComment = (manuscriptId, data) => post(`/api/v1/manuscript/${manuscriptId}/comment`, data)

/**
 * 获取稿件留言列表
 * @param {*} manuscriptId
 * @param {*} data
 */
export const getPaperCommentList = (manuscriptId, data) => get(`/api/v1/manuscript/${manuscriptId}/comments`, data)

/**
 * 获取图片验证码
 * @param {*} data
 */
export const getImageCaptcha = (data) => get(`/api/v1/auth/tpyzm`, data)

/**
 * 稿件重新报价
 * @param {*} manuscriptId
 * @param {*} data
 */
export const requotePaper = (manuscriptId, data) => put(`/admin/api/v1/manuscript/${manuscriptId}/requote`, data)

/**
 * 获取相关稿件列表，用户端
 * @param {*} id
 * @param {*} data
 */
export const getPaperRelated = (manuscriptId, data) => get(`/api/v1/manuscript/${manuscriptId}/related`, data)



// WEBPACK FOOTER //
// ./src/api/index.js